import { render } from "./TopMenuComponent.vue?vue&type=template&id=68240efc"
import script from "./TopMenuComponent.vue?vue&type=script&lang=js"
export * from "./TopMenuComponent.vue?vue&type=script&lang=js"

import "./TopMenuComponent.vue?vue&type=style&index=0&id=68240efc&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__